<template>
    <div class="description-editor">
        <text-complete
            v-if="standardPlaceholders"
            v-model="model"
            areaClass="textcomplete"
            :strategies="strategies"
            :placeholder="placeholder"
        ></text-complete>
        <div
            class="preview"
            v-html="preview"
        ></div>
    </div>
</template>

<script>
import TextComplete from 'v-textcomplete';
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'description-editor',
    props: ['datafields', 'value', 'placeholder'],
    components: {
        TextComplete,
    },
    mounted() {
        this.loadStandardPlaceholders();
    },
    watch: {
        model() {
            this.$emit('input', this.model);
        },
    },
    data() {
        return {
            model: this.value,
        };
    },
    computed: {
        preview() {
            let content = this.value || '';
            if (this.datafieldOptions && this.strategies) {
                Object.values(this.datafieldOptions).forEach((df) => {
                    const placeholder = '{' + df.datafieldId + '}';
                    content = content.replaceAll(
                        placeholder,
                        this.strategies[0].template(df.name, true)
                    );
                });
            }
            return content;
        },
        datafieldOptions() {
            if (!this.standardPlaceholders) {
                return null;
            }
            const datafieldOptions = {};
            this.standardPlaceholders.forEach((placeholder) => {
                const name = placeholder.substr(1, placeholder.length - 2);
                datafieldOptions[name] = {
                    datafieldId: name,
                    name: name,
                    standard: true,
                };
            });
            if (this.datafields) {
                this.datafields.forEach((x) => {
                    datafieldOptions[x.name] = x;
                });
            }
            return datafieldOptions;
        },
        strategies() {
            const self = this;
            return [
                {
                    match: /(^|\s)\{([A-Za-z0-9+\-\_]*)$/,
                    search(term, callback) {
                        term = term.toLowerCase();
                        const keys = Object.keys(self.datafieldOptions);
                        const matchingOptions = keys
                            .filter(function (name) {
                                return name.toLowerCase().startsWith(term);
                            })
                            .slice(0, 20);

                        callback(matchingOptions);
                    },
                    template(name, addBraces) {
                        const option = self.datafieldOptions[name];
                        const firstBrace = addBraces ? '{' : '';
                        const secondBrace = addBraces ? '}' : '';

                        if (option.standard) {
                            return (
                                '<span>' +
                                firstBrace +
                                option.name +
                                secondBrace +
                                '</span>'
                            );
                        } else {
                            return (
                                '<span>' +
                                firstBrace +
                                option.name +
                                ' - #' +
                                option.datafieldId +
                                secondBrace +
                                '</span>'
                            );
                        }
                    },
                    replace(name) {
                        const option = self.datafieldOptions[name];
                        return '$1{' + option.datafieldId + '} ';
                    },
                },
            ];
        },
        ...mapGetters({
            standardPlaceholders: 'productTypeSettings/getStandardPlaceholders',
        }),
    },
    methods: {
        ...mapActions({
            loadStandardPlaceholders:
                'productTypeSettings/loadStandardPlaceholders',
        }),
    },
};
</script>
